export { default } from "./settings-notifications.native";
